import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from 'date-fns';

export const formatDateUntil = (
  closed_at: number,
  daysString: string,
  secondsString: string,
) => {
  const closed = new Date(closed_at * 1000);
  const days = differenceInDays(closed, Date.now());

  if (days > 0) {
    return `${days} ${daysString}`;
  }

  const hours = differenceInHours(closed, Date.now());
  const minutes = differenceInMinutes(closed, Date.now()) % 60;
  const seconds = differenceInSeconds(closed, Date.now()) % 60;

  if (!hours && !minutes) {
    return `${seconds} ${secondsString}`;
  }

  if (!hours) {
    return `${minutes}:${seconds}`;
  }

  return `${hours}:${minutes}:${seconds}`;
};

export const isLessThanADay = (closedAt: number) =>
  differenceInDays(new Date(closedAt * 1000), new Date()) === 0;
